export default __webpack_public_path__ + "static/box-3-aba2f17aaa427dcef1674c5fb0ddfa21.png";